import React from "react";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TagIcon from "Tag";

import { Tag } from "constructs/Tag";
import { ObfuscationState } from "./PostImage";


export interface ObfuscatedImageExplanationProps {
  imageTags: Array<Tag>;
  userImageState: ObfuscationState;

  onClick?: ((event: React.MouseEvent<HTMLButtonElement, React.MouseEvent>) => void) | undefined;
  onMouseEnter: (event: any) => void;
  // onMouseLeave: (event: any) => void;
}


const ObfuscatedImageExplanation = ({ imageTags, userImageState, ...props }: ObfuscatedImageExplanationProps) => {
  
  const handleClick = (event: any) => {
    if (!props.onClick) {
      return;
    }
    props.onClick(event);
  }

  const buttonText = React.useMemo(() => updateButtonText(userImageState), [ userImageState ])

  return (
    <span
      onMouseEnter={props.onMouseEnter}
      // onMouseLeave={props.onMouseLeave}
    >
      <Stack alignContent='center' spacing={2} m={2}>
        <Button 
          disableRipple
          color="secondary"
          variant='contained'
          onClick={ handleClick }
        >
          { buttonText }
        </Button>
        <Typography>
          This image is obfuscated because it contains the following tags at a threshold beyond the magnitude of your exclusion criteria.
        </Typography>
        <Stack direction='column' flexWrap='wrap' spacing={ 2}>
          {
            imageTags.map((tag, index) => <TagIcon key={tag.id} tag={tag} tooltipPlacement='right-start' />)
          }
        </Stack>
      </Stack>
    </span>
  )
};

export default ObfuscatedImageExplanation


function updateButtonText(userImageState: ObfuscationState) {
    switch (userImageState) {
      case "on":
        return "Hide";
      case "partial":
        return "Show More";
      case "off":
        return "Show";
  };
}